<template>
  <v-btn
    v-bind="{
      color: brandPrimary,
      height: 40,
      rounded: false,
      block: true,
      theme: 'dark',
      variant: 'flat',
      ...$props,
      ...$attrs,
    }"
    class="rounded-lg"
  >
    <slot />
  </v-btn>
</template>
<script>
import { useColors } from '@/composables/colors';

export default {
  name: 'DpplSignupFormButton',
  setup() {
    const { brandPrimary } = useColors();

    return { brandPrimary };
  },
};
</script>
<style scoped>
.v-btn.v-btn--size-default {
  font-size: 13px;
  text-transform: capitalize;
}
</style>
